export enum Aggregators {
  Plaid,
  MX,
  Yodlee,
}

export const API_URL = process.env.REACT_APP_API_URL;
export const ENV = process.env.REACT_APP_ENV;
export const POLYGON_API_KEY = process.env.REACT_APP_POLYGON_API_KEY;
export const IEX_API_KEY = process.env.REACT_APP_IEX_API_KEY;
export const AGGREGATOR = Aggregators.Plaid;
export const GOOGLE_ANALYTICS_KEY = process.env.REACT_APP_GOOGLE_ANALYTICS_KEY;
export const YODLEE_FAST_LINK_URL = process.env.REACT_APP_YODLEE_FAST_LINK_URL;
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID;
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
